import React, { useEffect, useState } from "react";
import { ReloadIco, TransfersIco } from "../../../../../modules/CustomIcons";
import { Button, Spin } from "antd";
import { Spinner } from "constants/constants";
import { setTableData } from 'store/actions/transfers';
import { setTransferWidgetLoading } from 'store/actions/accountStatement';
import { useActions } from '../../../../hooks/useActions'
import { dateFormatter } from "../../../../services/helper";
import { TransactionsCount, getWidgetTransactions } from "../../../../services/widgets/Widget";
import { getCurrentCompany } from "../../../../services/user";
import { connect } from "react-redux";
import moment from "moment";
import { getBusinessDate } from '../../../../services/transfers';
import { useHistory } from "react-router-dom";
import { checkAnyPermission } from "../../../../services/permission"
import {setSourceComingPage } from "../../../../store/actions/transfers";
import { useTranslation } from "react-i18next";

const Transactions: React.FC<any> = ({ companyData, loading, accountLoading, balanceLoading, ibanNumber }) => {
    const {t} = useTranslation();
    const { setTableData, setTransferWidgetLoading, setSourceComingPage } = useActions()
    const history = useHistory();

    const [tableData, setTableDataState] = useState<TransactionsCount[]>();
    const [tableLoading, setTableLoading] = useState(Spinner);
    const [filterDateTime, setFilterDateTime] = useState(dateFormatter());
    const [sumCount, setSumCount] = useState<number>(0);
    const [CLOSED, setCLOSED] = useState<number>(0);
    const [PENDING_ALL, setPENDING_ALL] = useState<number>(0);
    const [BANK_ERROR, setBANK_ERROR] = useState<number>(0);
    const [SEND_TO_BANK, setSEND_TO_BANK] = useState<number>(0);
    const [BANK_REJECTED, setBANK_REJECTED] = useState<number>(0);
    const [EXPIRED, setEXPIRED] = useState<number>(0);
    const [BANK_SUCCESS, setBANK_SUCCESS] = useState<number>(0);
    const [PENDING_SIGNER, setPENDING_SIGNER] = useState<number>(0);
    const [PENDING_APPROVER, setPENDING_APPROVER] = useState<number>(0);
    const [DELETED, setDELETED] = useState<number>(0);

    const names = {
        CLOSED: t("transfers.executedToday"),
        PENDING_ALL: t("transfers.signConfirmation"),
        BANK_ERROR: t("transfers.notProcessed"),
        SEND_TO_BANK: "Banka göndərilməyə hazırdır",
        BANK_REJECTED: t("transfers.rejected"),
        EXPIRED: t("transfers.expired"),
        BANK_SUCCESS: t("transfers.sentToBank"),
        PENDING_SIGNER: t("transfers.forSigning"),
        PENDING_APPROVER: t("transfers.forConfirmation"),
        DELETED: t("transfers.deleted")
    };

    const updateLoading = () => setTransferWidgetLoading(true);

    const fetchData = async () => {
        setTableLoading({
            ...tableLoading,
            spinning: true
        });


        const today = moment(new Date()).format("DD.MM.YYYY");
        const data = await getWidgetTransactions(today, today, ibanNumber?.iban);
        const filter_data = data.filter(row => row.count != 0);
        let sum_count: number = 0;
        setTableDataState(old_data => filter_data);
        setFilterDateTime(old_date => dateFormatter());

        setCLOSED(0);
        setPENDING_ALL(0);
        setBANK_ERROR(0);
        setSEND_TO_BANK(0);
        setBANK_REJECTED(0);
        setEXPIRED(0);
        setBANK_SUCCESS(0);
        setPENDING_SIGNER(0);
        setPENDING_APPROVER(0);
        setDELETED(0);

        for (let row of filter_data) {
            sum_count += row.count;

            if (row.status === "CLOSED") {
                setCLOSED(row.count);
            } else if (row.status === "PENDING_ALL") {
                setPENDING_ALL(row.count);
            } else if (row.status === "BANK_ERROR") {
                setBANK_ERROR(row.count);
            } else if (row.status === "SEND_TO_BANK") {
                setSEND_TO_BANK(row.count);
            } else if (row.status === "BANK_REJECTED") {
                setBANK_REJECTED(row.count);
            } else if (row.status === "EXPIRED") {
                setEXPIRED(row.count);
            } else if (row.status === "BANK_SUCCESS") {
                setBANK_SUCCESS(row.count);
            } else if (row.status === "PENDING_SIGNER") {
                setPENDING_SIGNER(row.count);
            } else if (row.status === "PENDING_APPROVER") {
                setPENDING_APPROVER(row.count);
            } else if (row.status === "DELETED") {
                setDELETED(row.count);
            }
        }
        setSumCount(sum_count);
        setTableLoading({
            ...tableLoading,
            spinning: false
        });

        setTransferWidgetLoading(false)
    };

    useEffect(() => {
        if (!loading && !balanceLoading && !accountLoading)
            fetchData();
    }, [companyData, loading, accountLoading, balanceLoading]);

    const isTransferPermission = checkAnyPermission(['AZIPS', 'SWIFT', 'XOHKS', 'BATCH_PAYMENT', 'EXCHANGE', 'INTERNAL', 'OWN_ACCOUNT', 'DXA', 'IPS_OTH', 'IPS_BDG', 'IPS_VAT', 'EDV', 'SWIFT_RUB', 'TEMPLATE', 'SALARY_TOTAL'])
    const handleTransfersData = async (name: string) => {
        // const businessDateData = await getBusinessDate()
        // console.log('====businessDateData=======', businessDateData, moment());

        // const values = {
        //     status: name,
        //     startDate:  moment().subtract(15, "days"),
        //     endDate: moment(businessDate).format('YYYY-MM-DD'),
        // }
        //@ts-ignore
        // setBusinessDate(businessDateData)
        if( isTransferPermission){
            history.push(`/transfers/${name}`)
            setSourceComingPage({from: "fromWidget"})
        }
        //@ts-ignore
        setTableData([])
    }

    return (
        <>
            <div className='right_side_box full'>

                <div className='full right_side_box_title flex justify_between'>

                    <div className='flex right_side_box_title_left'>
                        <TransfersIco className={'right_side_transaction_ico'} />

                        <div className='flex direction_column right_side_box_title_left_title'>
                            <h5>{t("home.transfers")} <span>({sumCount})</span></h5>
                            <p>{filterDateTime}</p>
                        </div>
                    </div>

                    <Button icon={<ReloadIco />} onClick={() => {
                        fetchData();
                        updateLoading();
                    }} className='transparent box_reload_ico' />

                </div>

                <div className='full right_side_box_content'>
                    <Spin{...tableLoading}>
                        <ul className={isTransferPermission ? 'full flex direction_column box_list' : 'full flex direction_column box_list noTransfr'}>
                        {
                            CLOSED > 0 && <li onClick={() => handleTransfersData('CLOSED')}>
                            <a>{names.CLOSED}</a>
                            <span className='flex justify_center align_center span_circle'>{CLOSED}</span>
                        </li>
                        } 

                        {
                            PENDING_SIGNER > 0 &&  <li onClick={() => handleTransfersData('PENDING_SIGNER')}>
                            <a>{names.PENDING_SIGNER}</a>
                            <span className='flex justify_center align_center span_circle'>{PENDING_SIGNER}</span>
                        </li>
                        } 


                        {
                            PENDING_APPROVER > 0 &&  <li onClick={() => handleTransfersData('PENDING_APPROVER')} >
                            <a>{names.PENDING_APPROVER}</a>
                            <span className='flex justify_center align_center span_circle'>{PENDING_APPROVER}</span>
                        </li>
                        } 

                        {
                            PENDING_ALL > 0 && <li onClick={() => handleTransfersData('PENDING_ALL')}>
                            <a>{names.PENDING_ALL}</a>
                            <span className='flex justify_center align_center span_circle'>{PENDING_ALL}</span>
                            </li>
                        } 
                        {/*{*/}
                        {/*    SEND_TO_BANK > 0 &&  <li onClick={() => handleTransfersData('SEND_TO_BANK')}>*/}
                        {/*    <a>{names.SEND_TO_BANK}</a>*/}
                        {/*    <span className='flex justify_center align_center span_circle'>{SEND_TO_BANK}</span>*/}
                        {/*</li>*/}
                        {/*} */}
                        {
                            BANK_ERROR > 0 &&  <li onClick={() => handleTransfersData('BANK_ERROR')}>
                            <a>{names.BANK_ERROR}</a>
                            <span className='flex justify_center align_center span_circle'>{BANK_ERROR}</span>
                        </li>
                        }


                        {
                            BANK_SUCCESS > 0 &&  <li onClick={() => handleTransfersData('BANK_SUCCESS')}>
                            <a>{names.BANK_SUCCESS}</a>
                            <span className='flex justify_center align_center span_circle'>{BANK_SUCCESS}</span>
                        </li>
                        } 

                        {
                            BANK_REJECTED > 0 &&  <li onClick={() => handleTransfersData('BANK_REJECTED')}>
                            <a>{names.BANK_REJECTED}</a>
                            <span className='flex justify_center align_center span_circle'>{BANK_REJECTED}</span>
                        </li>
                        }     

                        {
                            DELETED > 0 &&  <li onClick={() => handleTransfersData('DELETED')}>
                            <a>{names.DELETED}</a>
                            <span className='flex justify_center align_center span_circle'>{DELETED}</span>
                        </li>
                        }     


                        {
                            EXPIRED > 0 &&  <li onClick={() => handleTransfersData('EXPIRED')}>
                            <a>{names.EXPIRED}</a>
                            <span className='flex justify_center align_center span_circle'>{EXPIRED}</span>
                        </li>
                        }

                    </ul>
                    </Spin>
                </div>

            </div>
        </>
    )
}

const mapStateToProps = (state: any) => ({
    companyData: (state.user && state.user.companyData.result) ? state.user.companyData.result.customerNo : getCurrentCompany(),
    loading: state.user.isCompChange,
    balanceLoading: state.accountsStatement.balanceLoading,
    accountLoading: state.accountsStatement.accountLoading,
    ibanNumber: state.accountsStatement?.ibanNumber ?? {},
})
const mapDispatchToProps = { setTableData, setTransferWidgetLoading, setSourceComingPage }
export default connect(mapStateToProps, mapDispatchToProps)(Transactions)
